export default "__VITE_ASSET__2dc73d52__"